import * as types from './mutation_types'

export default {
  [types.SETTLEMENTREPORT_SHOW_RESET] (state) {
    Object.assign(state, {
      error: '',
      isLoading: false,
      retrieved: {}
    })
  },

  [types.SETTLEMENTREPORT_SHOW_SET_ERROR] (state, error) {
    Object.assign(state, { error })
  },

  [types.SETTLEMENTREPORT_SHOW_SET_RETRIEVED] (state, { retrieved, type }) {
    const assign = { ...state.retrieved }
    assign[type] = retrieved
    Object.assign(state, { retrieved: assign })
  },

  [types.SETTLEMENTREPORT_SHOW_TOGGLE_LOADING] (state) {
    Object.assign(state, { error: '', isLoading: !state.isLoading })
  }
}
